import { render, staticRenderFns } from "./workTypeTemplate.vue?vue&type=template&id=189dce97&scoped=true&"
import script from "./workTypeTemplate.vue?vue&type=script&lang=js&"
export * from "./workTypeTemplate.vue?vue&type=script&lang=js&"
import style0 from "./workTypeTemplate.vue?vue&type=style&index=0&id=189dce97&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189dce97",
  null
  
)

export default component.exports